/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "MakeCreditLinePaymentRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLineId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentAccountToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "MakeCreditLinePaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.MakeCreditLinePaymentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.MakeCreditLinePaymentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE MakeCreditLinePaymentRequest @ squareup/corporate_card/service/make_credit_line_payment.proto at 10:1
 */
export const MakeCreditLinePaymentRequest = $root.lookupType('squareup.corporate_card.service.MakeCreditLinePaymentRequest');
fixType(MakeCreditLinePaymentRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  creditLineId: {
    notEmpty: true
  },
  paymentMoney: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(MakeCreditLinePaymentRequest);
/**
 * SOURCE MakeCreditLinePaymentResponse @ squareup/corporate_card/service/make_credit_line_payment.proto at 40:1
 */
export const MakeCreditLinePaymentResponse = $root.lookupType('squareup.corporate_card.service.MakeCreditLinePaymentResponse');
fixType(MakeCreditLinePaymentResponse);
Builder.createAndAttachToType(MakeCreditLinePaymentResponse);